import { default as trainingemployeesTypes } from "./types";

const {
  ADD_TRAININGEMPLOYEE_REQUEST,
  ADD_TRAININGEMPLOYEE_SUCCESS,
  ADD_TRAININGEMPLOYEE_FAILURE,
  FETCH_TRAININGEMPLOYEES_REQUEST,
  FETCH_TRAININGEMPLOYEES_SUCCESS,
  FETCH_TRAININGEMPLOYEES_FAILURE,
} = trainingemployeesTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TRAININGEMPLOYEE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_TRAININGEMPLOYEE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: "",
      };
    case ADD_TRAININGEMPLOYEE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FETCH_TRAININGEMPLOYEES_REQUEST:
      return {
        ...state,
        isLoading: true,
        list: [],
      };
    case FETCH_TRAININGEMPLOYEES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_TRAININGEMPLOYEES_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
